fccd-pill-block {
  .pill-blocks ul {
    padding: 0;
    margin: 0;
  }
}
